const stripeElementOptions = {
    hidePostalCode: false,
    style: {
        base: {
            color: '#5f6a7d',
            lineHeight: '38px',
            '::placeholder': {
                color: '#afb4be',
            },
        },
        invalid: {
            color: '#eb5757',
            iconColor: '#eb5757',
        },
    },
};
export default stripeElementOptions;
